import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { RegistruService } from '../registru.service';
import { finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-add-registru',
    templateUrl: './add-registru.component.html',
    styleUrls: ['./add-registru.component.scss'],
})
export class AddRegistruComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    serieType$: any = [];
    judete!: Generic[];

    defaultParameter: { name: string; id: string } = {
        name: '-- Alegeți --',
        id: '-1',
    };

    tipPersoanaOptions = [
        { label: 'Fizică', value: 'fizica' },
        { label: 'Juridică', value: 'juridica' },
    ];

    taxOptions = [
        { label: 'Da', value: true },
        { label: 'Nu', value: false },
    ];

    form!: FormGroup;

    formCertificatUrbanism: FormGroup = new FormGroup({
        numar_certificat: new FormControl('', Validators.required),
        data_eliberarii: new FormControl(new Date(), Validators.required),
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_solicitarii: new FormControl(new Date(), Validators.required),
        judet: new FormControl('-1', [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl('', Validators.required),
        sector: new FormControl(''),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        numar_cadastral: new FormControl('', Validators.required),
        solicitant: new FormControl('', Validators.required),
        scop: new FormControl('', Validators.required),
        valabilitate: new FormControl(new Date(), Validators.required),
        // taxa_achitata: new FormControl('', Validators.required),
        intocmitor: new FormControl('', Validators.required),
    });

    formAutorizatiiConstruire: FormGroup = new FormGroup({
        numar_autorizatie: new FormControl('', Validators.required),
        data_eliberarii: new FormControl(new Date(), Validators.required),
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_solicitarii: new FormControl(new Date(), Validators.required),
        judet: new FormControl('-1', [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl('', Validators.required),
        sector: new FormControl(''),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        numar_cadastral: new FormControl('', Validators.required),
        solicitant: new FormControl('', Validators.required),
        scop: new FormControl('', Validators.required),
        suprafata_teren: new FormControl(''),
        suprafata_constructie: new FormControl(''),
        suprafata_desfasurata: new FormControl(''),
        suprafata_utila: new FormControl(''),
        suprafata_bucatarii: new FormControl(''),
        valoare: new FormControl('', Validators.required),
        valabilitate: new FormControl(new Date(), Validators.required),
        durata_executie: new FormControl('', Validators.required),
        intocmitor: new FormControl('', Validators.required),
    });

    formAdminDrum: FormGroup = new FormGroup({
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_eliberarii: new FormControl(new Date(), Validators.required),
        judet: new FormControl('-1', [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl('', Validators.required),
        sector: new FormControl(''),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        numar_cadastral: new FormControl('', Validators.required),
        solicitant: new FormControl('', Validators.required),
        scop: new FormControl('', Validators.required),
        suprafata_teren: new FormControl(''),
        suprafata_constructie: new FormControl(''),
        suprafata_desfasurata: new FormControl(''),
        suprafata_utila: new FormControl(''),
        suprafata_bucatarii: new FormControl(''),
        valoare: new FormControl('', Validators.required),
        valabilitate: new FormControl(new Date(), Validators.required),
        durata_executie: new FormControl('', Validators.required),
        intocmitor: new FormControl('', Validators.required),
    });

    formAvize: FormGroup = new FormGroup({
        numar_aviz: new FormControl('', Validators.required),
        data_intrarii: new FormControl(new Date(), Validators.required),
        tip_persoana: new FormControl('', Validators.required),
        continut: new FormControl('', Validators.required),
        data_iesire: new FormControl(new Date(), Validators.required),
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_solicitarii: new FormControl(new Date(), Validators.required),
        judet: new FormControl('-1', [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl('', Validators.required),
        sector: new FormControl(''),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        intocmitor: new FormControl('', Validators.required),
    });

    formAvizStudiuPub: FormGroup = new FormGroup({
        numar_aviz: new FormControl('', Validators.required),
        beneficiar: new FormControl('', Validators.required),
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_solicitarii: new FormControl(new Date(), Validators.required),
        judet: new FormControl('-1', [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl('', Validators.required),
        sector: new FormControl(''),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        scop: new FormControl('', Validators.required),
        intocmitor: new FormControl('', Validators.required),
    });

    formAvizPUD: FormGroup = new FormGroup({
        numar_aviz: new FormControl('', Validators.required),
        data_eliberarii: new FormControl(new Date(), Validators.required),
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_solicitarii: new FormControl(new Date(), Validators.required),
        solicitant: new FormControl('', Validators.required),
        cnp_cui: new FormControl('', Validators.required),
        judet: new FormControl('-1', [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl('', Validators.required),
        sector: new FormControl(''),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        scop: new FormControl('', Validators.required),
        suprafata_teren: new FormControl(''),
        suprafata_constructie: new FormControl(''),
        suprafata_desfasurata: new FormControl(''),
        suprafata_utila: new FormControl(''),
        suprafata_bucatarii: new FormControl(''),
        nr_cad_teren: new FormControl('', Validators.required),
    });

    formSupraetajare: FormGroup = new FormGroup({
        numar_aviz: new FormControl('', Validators.required),
        data_eliberarii: new FormControl(new Date(), Validators.required),
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_solicitarii: new FormControl(new Date(), Validators.required),
        solicitant: new FormControl('', Validators.required),
        cnp_cui: new FormControl('', Validators.required),
        judet: new FormControl('-1', [Validators.required, control => control.value === '-1' ? { defaultSelected: true } : null]),
        oras: new FormControl('', Validators.required),
        sector: new FormControl(''),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        scop: new FormControl('', Validators.required),
        suprafata_teren: new FormControl(''),
        suprafata_constructie: new FormControl(''),
        suprafata_desfasurata: new FormControl(''),
        suprafata_utila: new FormControl(''),
        suprafata_bucatarii: new FormControl(''),
        nr_cad_teren: new FormControl('', Validators.required),
    });

    formRegistruCU: FormGroup = new FormGroup({
        numar_certificat: new FormControl('', Validators.required),
        data_eliberarii: new FormControl(new Date(), Validators.required),
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_solicitarii: new FormControl(new Date(), Validators.required),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        numar_cadastral: new FormControl('', Validators.required),
        carte_funciara: new FormControl('', Validators.required),
        scop: new FormControl('', Validators.required),
        solicitant: new FormControl('', Validators.required),
        intocmitor: new FormControl('', Validators.required),
    });

    formNotificari: FormGroup = new FormGroup({
        numar_notificare: new FormControl('', Validators.required),
        data_eliberarii: new FormControl(new Date(), Validators.required),
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_solicitarii: new FormControl(new Date(), Validators.required),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        numar_cadastral: new FormControl('', Validators.required),
        carte_funciara: new FormControl('', Validators.required),
        scop: new FormControl('', Validators.required),
        solicitant: new FormControl('', Validators.required),
        intocmitor: new FormControl('', Validators.required),
    });

    formAutorizatieConstruireDesfiintare: FormGroup = new FormGroup({
        numar_autorizatie: new FormControl('', Validators.required),
        data_eliberarii: new FormControl(new Date(), Validators.required),
        numar_cerere_registratura: new FormControl('', Validators.required),
        numar_cerere: new FormControl('', Validators.required),
        data_solicitarii: new FormControl(new Date(), Validators.required),
        strada: new FormControl('', Validators.required),
        numar: new FormControl('', Validators.required),
        bloc: new FormControl(''),
        scara: new FormControl(''),
        etaj: new FormControl(''),
        apartament: new FormControl(''),
        numar_cadastral: new FormControl('', Validators.required),
        solicitant: new FormControl('', Validators.required),
        scop: new FormControl('', Validators.required),
        suprafata_teren: new FormControl(''),
        suprafata_constructie: new FormControl(''),
        suprafata_utila: new FormControl(''),
        suprafata_bucatarii: new FormControl(''),
        valoare_lucrari: new FormControl('', Validators.required),
        valoare_taxa: new FormControl('', Validators.required),
        valabilitate: new FormControl(new Date(), Validators.required),
        durata_executie: new FormControl('', Validators.required),
        intocmitor: new FormControl('', Validators.required),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: string,
        private dialogRef: MatDialogRef<AddRegistruComponent>,
        private registruService: RegistruService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) {
        this.processToken();
        this.initializeForm(this.data);
        this.loadJudete();
        console.log(this.data, 'check here pls')
    }

    ngOnInit(): void { }

    initializeForm(id: string) {
        switch (id) {
            case 'acord_administrator_drum':
                // Administrator Drum
                this.form = this.getFormAdminDrum();
                break;
            case 'autorizatii-construire':
                // Autorizatii de construire
                this.form = this.getFormAutorizatiiConstruire();
                break;
            case 'avize':
                // Avize
                this.form = this.getFormAvize();
                break;
            case 'aviz-principiu-studiu-publicitar':
                // Aviz Studiu Publicitar
                this.form = this.getFormAvizStudiuPublicitar();
                break;
            case 'aviz-pud':
                // Aviz PUD
                this.form = this.getFormAvizPUD();
                break;
            case 'aviz-supraetajare':
                // Aviz Supraetajare
                this.form = this.getFormAvizSupraetajare();
                break;
            case 'certificate-urbanism':
                // Certificat de Urbanism
                this.form = this.getFormCertificatUrbanism();
                break;
            case 'construire_desfiintare':
                // Registru Construire/Desfiintare (CD)
                this.form = this.getFormRegistruCU();
                break;
            case 'construire_desfiintare_ingineresti':
                // Registru Construire/Desfiintare lucrari ingineresti (IN)
                this.form = this.getFormRegistruCU();
                break;
            case 'operatiuni_notariale':
                // Registru Operatiuni Notariale (OC)
                this.form = this.getFormRegistruCU();
                break;
            case 'certificate_urbanism_informare':
                // Registru CU de Informare (IF)
                this.form = this.getFormRegistruCU();
                break;
            case 'autorizatie_construire_desfiintare':
                // Registru Autorizatie de Construire/Desfiintare
                this.form = this.getFormAutorizatieConstruireDesfiintare();
                break;
            case 'notificari':
                // Registru Notificari
                this.form = this.getFormNotificari();
                break;
            default:
                console.log('Not recognized');
        }
    }

    getFormAdminDrum(): FormGroup {
        return this.formAdminDrum;
    }

    getFormAutorizatiiConstruire(): FormGroup {
        return this.formAutorizatiiConstruire;
    }

    getFormAvize(): FormGroup {
        return this.formAvize;
    }

    getFormAvizStudiuPublicitar(): FormGroup {
        return this.formAvizStudiuPub;
    }

    getFormAvizPUD(): FormGroup {
        return this.formAvizPUD;
    }

    getFormAvizSupraetajare(): FormGroup {
        return this.formSupraetajare;
    }

    getFormCertificatUrbanism(): FormGroup {
        return this.formCertificatUrbanism;
    }

    getFormRegistruCU(): FormGroup {
        return this.formRegistruCU;
    }

    getFormNotificari(): FormGroup {
        return this.formNotificari;
    }

    getFormAutorizatieConstruireDesfiintare(): FormGroup {
        return this.formAutorizatieConstruireDesfiintare;
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.registruService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const formData = { ...this.form.value };

        Object.keys(formData).forEach(key => {
            const value = formData[key];

            console.log(value);
            if (value instanceof Date) {
                formData[key] = this.formatDate(value);
            }
        });

        this.registruService
            .addRegistruDocOficial(formData, this.data)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    loadJudete() {
        this.registruService
            .getJudete()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]))
            .subscribe({
                next: (results) => {
                    this.judete = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                }
            })
    }
}
